var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.25C7 3.10938 6.89063 3 6.75 3H6.25C6.10938 3 6 3.10938 6 3.25V6H4.25C4.10938 6 4 6.10938 4 6.25V6.75C4 6.89063 4.10938 7 4.25 7H6.75C6.89063 7 7 6.89063 7 6.75V3.25ZM10.25 6C10.25 8.34375 8.34375 10.25 6 10.25C3.65625 10.25 1.75 8.34375 1.75 6C1.75 3.65625 3.65625 1.75 6 1.75C8.34375 1.75 10.25 3.65625 10.25 6ZM12 6C12 2.6875 9.3125 0 6 0C2.6875 0 0 2.6875 0 6C0 9.3125 2.6875 12 6 12C9.3125 12 12 9.3125 12 6Z",
    fill: "#B3B3B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.55145844d37fdca06db6795fd08f8398.svg";
export { ForwardRef as ReactComponent };